import * as types from './mutation-types';
import plantcontainerService from '../../services/plantcontainer'
import { createServiceCall } from '../actionsUtil'

export const getEmptyPlantContainer = createServiceCall({
  mainAction: types.GET_EMPTY_REQUEST,
  serviceFunction: plantcontainerService.getEmptyPlantContainer,
  successAction: types.GET_EMPTY_SUCCESS,
  successDataProperty: "getEmptyPlantContainer",
  failureAction: types.GET_EMPTY_FAILURE
})

export const getPlantContainer = createServiceCall({
  mainAction: types.GET_CONTAINER_REQUEST,
  serviceFunction: plantcontainerService.getPlantContainer,
  successAction: types.GET_CONTAINER_SUCCESS,
  successDataProperty: "getPlantContainer",
  failureAction: types.GET_CONTAINER_FAILURE
});

export const getPlantContainerList = createServiceCall({
  mainAction: types.GET_MULTIPLE_CONTAINERS_REQUEST,
  serviceFunction: plantcontainerService.getPlantContainerList,
  successAction: types.GET_MULTIPLE_CONTAINERS_SUCCESS,
  successDataProperty: "getPlantContainerList",
  failureAction: types.GET_MULTIPLE_CONTAINERS_FAILURE
});

export const setEmptyPlantContainer = function({commit}, emptyPlantContainer) {
  commit(types.SET_EMPTY_PLANT_CONTAINER, emptyPlantContainer)
}
export const setEmptyPlantContainers = function({commit}, emptyPlantContainers) {
  commit(types.SET_EMPTY_PLANT_CONTAINERS, emptyPlantContainers)
}
